module.exports = __webpack_public_path__ + "static/media/whatsapp.0aa70ce6.svg";